<script setup>
import {DialogsWrapper} from 'vuejs-confirm-dialog';
import AppLoader from '@/components/layouts/AppLoader.vue';
import {useI18n} from 'vue-i18n'
import {getLangToSet} from '@/helper';

const {locale} = useI18n();
//locale.value = getLangToSet();
locale.value = getLangToSet();

</script>

<template>
  <AppLoader></AppLoader>
  <div class="app-container">
    <div class="app-container-content">
      <router-view/>
      <DialogsWrapper/>
    </div>
  </div>
</template>